exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-3a266f72]{text-align:center;position:absolute;top:50%;margin-top:-50%;bottom:0;left:0;right:0;padding:0 5vw}.btn[data-v-3a266f72]{display:inline-block;width:50%;padding:2vw;background-color:#3e94ff;border-radius:1.33333vw;color:#fff;margin-top:5vw}", ""]);

// exports
